import { useNavigate } from "react-router-dom";
import Breadcrumb from "@/components/base/Breadcrumb";
import JsonLD from "@/components/base/JsonLD";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const articles = [
  {
    id: "hipoteczny",
    tag: "Kredyt hipoteczny",
    title: "Kredyt hipoteczny prostymi słowami — za i przeciw",
    readTime: "5 minut",
    date: "lipiec 2026",
    excerpt:
      "Jak naprawdę działa, ile kosztuje i co zrobić, żeby dostać lepsze warunki.",
  },
  {
    id: "mlodzi",
    tag: "Dla młodych",
    title: "Dlaczego młodym tak trudno o kredyt — i co można z tym zrobić",
    readTime: "6 minut",
    date: "lipiec 2026",
    excerpt:
      "Umowy zlecenia, brak wkładu, krótki staż — i sposoby, żeby to obejść.",
  },
  {
    id: "konsolidacja",
    tag: "Konsolidacja",
    title: "Konsolidacja kredytów — ratunek czy pułapka?",
    readTime: "5 minut",
    date: "lipiec 2026",
    excerpt:
      "Kiedy jedna rata naprawdę pomaga, a kiedy tylko odsuwa problem.",
  },
  {
    id: "zdolnosc",
    tag: "Zdolność kredytowa",
    title: "7 sposobów na wyższą zdolność kredytową",
    readTime: "4 minut",
    date: "lipiec 2026",
    excerpt:
      "Proste ruchy, które potrafią podnieść zdolność o kilkadziesiąt tysięcy.",
  },
  {
    id: "start-2026",
    tag: "Praktyczny start",
    title: "Kredyt w sierpniu 2026: od czego zacząć, zanim pójdziesz do banku",
    readTime: "6 minut",
    date: "sierpień 2026",
    excerpt:
      "Prosty plan przygotowania do kredytu: bez presji, bez zgadywania i bez zbędnych zapytań.",
  },
  {
    id: "stala-czy-zmienna",
    tag: "Rata kredytu",
    title: "Stała czy zmienna rata? Jak podjąć decyzję spokojnie",
    readTime: "5 minut",
    date: "sierpień 2026",
    excerpt:
      "Nie ma jednej dobrej odpowiedzi. Zobacz, które pytania naprawdę pomagają wybrać.",
  },
];

const blogSchema = {
  "@context": "https://schema.org",
  "@type": "Blog",
  name: "Blog EXPERT KREDYTOWY – kredyty prostymi słowami",
  inLanguage: "pl-PL",
  author: {
    "@type": "Person",
    name: "Jan Wojdyła",
    jobTitle: "Broker finansowy i ekspert kredytowy",
  },
  publisher: {
    "@type": "Organization",
    name: "EXPERT KREDYTOWY",
  },
  blogPost: articles.map((a) => ({
    "@type": "BlogPosting",
    headline: a.title,
    datePublished: "2026-07-26",
    author: { "@type": "Person", name: "Jan Wojdyła" },
  })),
};

function ArticleNavCard({
  article,
  index,
}: {
  article: (typeof articles)[number];
  index: number;
}) {
  const handleClick = () => {
    const el = document.getElementById(article.id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <button
      onClick={handleClick}
      className="text-left bg-white border border-background-200 rounded-xl p-5 hover:-translate-y-1 hover:border-primary-300 hover:shadow-lg transition-all cursor-pointer"
    >
      <div className="text-[11px] font-extrabold tracking-widest text-primary-600 uppercase">
        Artykuł {index + 1}
      </div>
      <h3 className="text-sm font-extrabold tracking-tight leading-snug mt-2 mb-2">
        {article.title}
      </h3>
      <p className="text-xs text-foreground-500 leading-relaxed">
        {article.excerpt}
      </p>
      <span className="text-xs font-bold text-primary-600 mt-3 inline-block">
        Czytaj &rarr;
      </span>
    </button>
  );
}

function ArticleSection({
  tag,
  title,
  readTime,
  date,
  children,
  id,
}: {
  tag: string;
  title: string;
  readTime: string;
  date: string;
  children: React.ReactNode;
  id: string;
}) {
  return (
    <article
      id={id}
      className="max-w-3xl mx-auto mb-10 bg-white border border-background-200 rounded-2xl shadow-sm p-6 md:p-10 scroll-mt-24"
    >
      <div className="text-[11px] font-extrabold tracking-widest text-primary-600 uppercase mb-2">
        {tag}
      </div>
      <h2 className="text-xl md:text-2xl font-extrabold tracking-tight leading-tight mb-2">
        {title}
      </h2>
      <div className="text-xs text-foreground-400 font-semibold mb-6">
        Czas czytania: {readTime} · {date}
      </div>
      {children}
      <div className="flex items-center gap-4 border-t border-background-200 mt-8 pt-5 flex-wrap">
        <div className="w-12 h-12 rounded-full bg-foreground-900 text-white flex items-center justify-center font-extrabold text-sm shrink-0">
          JW
        </div>
        <div>
          <div className="text-[10px] font-bold tracking-widest text-foreground-400 uppercase">
            Przygotował
          </div>
          <div className="text-sm font-extrabold">Jan Wojdyła</div>
          <div className="text-xs text-foreground-500">
            Broker finansowy i ekspert kredytowy · 25 lat w finansach · Sanok i
            Podkarpacie
          </div>
        </div>
      </div>
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="mt-4 text-xs font-bold text-primary-600 hover:text-primary-500 transition-colors cursor-pointer"
      >
        &uarr; Wróć do listy artykułów
      </button>
    </article>
  );
}

function Callout() {
  return (
    <div className="bg-foreground-900 text-white rounded-xl p-5 md:p-6 my-6 flex flex-wrap items-center gap-4 justify-between">
      <p className="text-sm text-foreground-300 max-w-md m-0">
        <b className="text-white">Chcesz wiedzieć, ile kredytu możesz dostać?</b>{" "}
        Ekspert kredytowy policzy Twoją zdolność w kilkunastu bankach — bezpłatnie.
      </p>
      <a
        href="tel:698084044"
        className="inline-flex items-center gap-2 bg-primary-500 text-white font-extrabold px-6 py-3 rounded-full text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
      >
        <i className="ri-phone-line" />
        698 084 044
      </a>
    </div>
  );
}

function ProsCons({
  pros,
  cons,
}: {
  pros: string[];
  cons: string[];
}) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 my-5">
      <div className="bg-green-50 border border-green-200 rounded-xl p-5">
        <h4 className="text-[11px] font-extrabold tracking-widest uppercase text-green-700 mb-3">
          Plusy
        </h4>
        <ul className="list-none m-0 p-0">
          {pros.map((p, i) => (
            <li
              key={i}
              className="py-1 pl-6 relative text-sm text-foreground-700"
            >
              <span className="absolute left-1 top-[11px] w-[7px] h-[7px] rounded-full bg-green-600" />
              {p}
            </li>
          ))}
        </ul>
      </div>
      <div className="bg-red-50 border border-red-200 rounded-xl p-5">
        <h4 className="text-[11px] font-extrabold tracking-widest uppercase text-red-700 mb-3">
          Minusy
        </h4>
        <ul className="list-none m-0 p-0">
          {cons.map((c, i) => (
            <li
              key={i}
              className="py-1 pl-6 relative text-sm text-foreground-700"
            >
              <span className="absolute left-1 top-[11px] w-[7px] h-[7px] rounded-full bg-red-600" />
              {c}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

function ExampleBox({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="bg-primary-50 border border-primary-200 rounded-xl p-4 md:p-5 my-5 text-sm text-primary-900">
      <b className="block text-[10px] font-extrabold tracking-widest uppercase mb-1">
        {title}
      </b>
      {children}
    </div>
  );
}

function WarnBox({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 md:p-5 my-5 text-sm text-amber-900">
      <b className="block text-[10px] font-extrabold tracking-widest uppercase mb-1">
        {title}
      </b>
      {children}
    </div>
  );
}

export default function BlogPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLD data={blogSchema} />
      <Navbar />

      <main>
        {/* Hero */}
        <section className="bg-foreground-900 text-white py-14 md:py-20">
          <div className="mx-auto max-w-[1440px] px-4 text-center md:px-8 lg:px-16 xl:px-20">
            <div className="mb-4 text-[11px] font-extrabold uppercase tracking-[3px] text-primary-400">
              Blog · Poradnik kredytowy
            </div>
            <h1 className="mx-auto mb-3 max-w-2xl text-2xl font-extrabold leading-tight tracking-tight md:text-4xl">
              Kredyty prostymi słowami
            </h1>
            <p className="mx-auto max-w-xl text-sm text-foreground-300 md:text-base">
              Bez bankowego żargonu i drobnego druku. Praktyczna wiedza od
              doradcy z 25-letnim doświadczeniem — żebyś podejmował decyzje z
              otwartymi oczami.
            </p>
          </div>
        </section>

        {/* Cards nav */}
        <section className="bg-background-100 py-10 md:py-12">
          <div className="mx-auto max-w-[1440px] px-4 md:px-8 lg:px-16 xl:px-20">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {articles.map((article, i) => (
                <ArticleNavCard key={article.id} article={article} index={i} />
              ))}
            </div>
          </div>
        </section>

        {/* Articles */}
        <section className="bg-background-100 py-6 md:py-10">
          <div className="mx-auto max-w-[1440px] px-4 md:px-8 lg:px-16 xl:px-20">
            <Breadcrumb />

            {/* Article 1 */}
            <ArticleSection
              id="hipoteczny"
              tag="Kredyt hipoteczny"
              title="Kredyt hipoteczny prostymi słowami — za i przeciw"
              readTime="5 minut"
              date="lipiec 2026"
            >
              <p className="text-sm md:text-base text-foreground-700 mb-4 leading-relaxed">
                Kredyt hipoteczny to{" "}
                <strong>
                  pożyczka na mieszkanie lub dom, w której bank zabezpiecza
                  się na tej nieruchomości
                </strong>{" "}
                — ma wpis w księdze wieczystej (to właśnie hipoteka). Dzięki
                temu zabezpieczeniu jest to najtańszy kredyt dostępny dla
                zwykłego człowieka. W zamian: więcej formalności i zobowiązanie
                na 20–35 lat.
              </p>

              <h3 className="text-base md:text-lg font-extrabold tracking-tight mt-6 mb-2">
                Z czego składa się rata?
              </h3>
              <p className="text-sm md:text-base text-foreground-700 mb-4 leading-relaxed">
                Z dwóch części: <strong>kapitału</strong> (oddajesz pożyczone) i{" "}
                <strong>odsetek</strong> (zarobek banku). Oprocentowanie to
                wskaźnik rynkowy (np. WIBOR — na niego nikt nie ma wpływu) plus{" "}
                <strong>
                  marża banku — stała przez cały okres i możliwa do
                  wynegocjowania
                </strong>{" "}
                przed podpisaniem umowy.
              </p>

              <ExampleBox title="Na przykładzie">
                Kredyt 480 000 zł na 30 lat: przy oprocentowaniu ok. 5,6% rata
                to ok. 2 750 zł, przy 6,5% — już ok. 3 030 zł. Niecały punkt
                procentowy = prawie 300 zł miesięcznie i ok. 100 000 zł w całym
                okresie. Dlatego porównywanie banków to nie kosmetyka.
              </ExampleBox>

              <h3 className="text-base md:text-lg font-extrabold tracking-tight mt-6 mb-2">
                Za i przeciw — uczciwie
              </h3>
              <ProsCons
                pros={[
                  "Rata buduje Twój majątek, nie właściciela wynajmowanego mieszkania",
                  "Najtańszy kredyt na rynku dla osób prywatnych",
                  "Nieruchomości w długim okresie zwykle zyskują na wartości",
                  "Możesz nadpłacać i skracać kredyt",
                ]}
                cons={[
                  "Zobowiązanie na dekady — wymaga stabilnych dochodów",
                  "Przy racie zmiennej wzrost stóp podnosi ratę",
                  "Odsetki przez cały okres to często drugie tyle, ile pożyczasz",
                  "Koszty wejścia: wkład własny, notariusz, podatek",
                ]}
              />

              <h3 className="text-base md:text-lg font-extrabold tracking-tight mt-6 mb-2">
                Co możesz zrobić, żeby dostać lepsze warunki?
              </h3>
              <ul className="list-none m-0 p-0 mb-4">
                {[
                  "Sprawdź BIK zanim zrobi to bank — stare spóźnienia i zapomniane karty psują ocenę.",
                  "Zamknij niepotrzebne limity — bank liczy je jak dług, nawet nieużywane.",
                  "Nie zmieniaj pracy tuż przed wnioskiem — banki lubią staż.",
                  "Porównaj kilka banków — różnica między najtańszą a najdroższą ofertą to dziś nawet 150 000 zł.",
                  "Negocjuj marżę — przy dobrej zdolności bank ma pole do ustępstw.",
                ].map((item, i) => (
                  <li
                    key={i}
                    className="py-1.5 pl-7 relative text-sm md:text-base text-foreground-700"
                  >
                    <span className="absolute left-1 top-[14px] w-[7px] h-[7px] rounded-full bg-primary-500" />
                    <strong>{item.split(" — ")[0]}</strong>
                    {item.includes(" — ") && " — " + item.split(" — ")[1]}
                  </li>
                ))}
              </ul>

              <Callout />
            </ArticleSection>

            {/* Article 2 */}
            <ArticleSection
              id="mlodzi"
              tag="Dla młodych"
              title="Dlaczego młodym tak trudno o kredyt — i co można z tym zrobić"
              readTime="6 minut"
              date="lipiec 2026"
            >
              <p className="text-sm md:text-base text-foreground-700 mb-4 leading-relaxed">
                Zarabiasz nieźle, opłacasz wynajem droższy niż rata kredytu,
                którego bank Ci... nie chce dać. Brzmi znajomo? To codzienność
                ludzi przed trzydziestką. Nie dlatego, że banki nie lubią
                młodych — tylko dlatego, że{" "}
                <strong>
                  system oceny ryzyka nie pasuje do tego, jak dziś wygląda start
                  w dorosłość
                </strong>
                . Dobra wiadomość: prawie każdy z tych problemów da się obejść.
              </p>

              <h3 className="text-base md:text-lg font-extrabold tracking-tight mt-6 mb-2">
                Problem 1: umowa zlecenie, B2B, śmieciówka
              </h3>
              <p className="text-sm md:text-base text-foreground-700 mb-4 leading-relaxed">
                Bank kocha umowę o pracę na czas nieokreślony. Tymczasem młodzi
                pracują na zleceniach, dziełach i kontraktach B2B. Co ważne:{" "}
                <strong>te dochody też się liczą</strong> — tylko na innych
                zasadach. Przy zleceniu banki chcą zwykle 6–12 miesięcy ciągłości
                u tego samego zleceniodawcy, przy B2B — najczęściej 12 miesięcy
                działalności (część banków akceptuje krócej, jeśli wcześniej
                robiłeś to samo na etacie).
              </p>
              <p className="text-sm md:text-base text-foreground-700 mb-4 leading-relaxed">
                <strong>Co zrobić:</strong> nie zmieniaj formy zatrudnienia tuż
                przed wnioskiem, zbieraj ciągłość dochodu i wybierz bank, który
                najlepiej liczy właśnie Twoją formę — różnice między bankami są
                tu ogromne. To dokładnie ta wiedza, którą ekspert kredytowy ma w małym
                palcu.
              </p>

              <h3 className="text-base md:text-lg font-extrabold tracking-tight mt-6 mb-2">
                Problem 2: brak wkładu własnego
              </h3>
              <p className="text-sm md:text-base text-foreground-700 mb-4 leading-relaxed">
                Ceny mieszkań rosną szybciej, niż da się odkładać. Na
                400-tysięczne mieszkanie standardowy wkład 20% to 80 000 zł —
                dla większości młodych bariera nie do przeskoczenia w kilka lat.
              </p>
              <p className="text-sm md:text-base text-foreground-700 mb-2 leading-relaxed">
                <strong>Co zrobić:</strong>
              </p>
              <ul className="list-none m-0 p-0 mb-4">
                {[
                  "10% zamiast 20% — część banków akceptuje niższy wkład z ubezpieczeniem niskiego wkładu (nieco droższa rata, ale wejście dużo wcześniej).",
                  "Darowizna od rodziców — najbliższa rodzina (grupa zerowa) nie płaci podatku od darowizny, wystarczy zgłoszenie do urzędu w 6 miesięcy; banki normalnie akceptują taki wkład.",
                  "Książeczka mieszkaniowa, oszczędności z IKE/PPK — bywają zapomnianym źródłem gotówki.",
                  "Programy rządowe — pojawiają się i znikają (dopłaty, gwarancje wkładu); zanim złożysz wniosek, warto sprawdzić z doradcą, co aktualnie działa — to zmienia się co rok.",
                ].map((item, i) => (
                  <li
                    key={i}
                    className="py-1.5 pl-7 relative text-sm md:text-base text-foreground-700"
                  >
                    <span className="absolute left-1 top-[14px] w-[7px] h-[7px] rounded-full bg-primary-500" />
                    {item}
                  </li>
                ))}
              </ul>

              <h3 className="text-base md:text-lg font-extrabold tracking-tight mt-6 mb-2">
                Problem 3: brak historii kredytowej
              </h3>
              <p className="text-sm md:text-base text-foreground-700 mb-4 leading-relaxed">
                Paradoks: nigdy nic nie pożyczałeś, płacisz wszystko na czas — a
                bank widzi <strong>pustą kartkę</strong> i nie wie, czy można Ci
                ufać. Zero historii bywa gorsze niż drobne potknięcie sprzed lat.
              </p>
              <p className="text-sm md:text-base text-foreground-700 mb-4 leading-relaxed">
                <strong>Co zrobić:</strong> na 12–18 miesięcy przed planowanym
                kredytem zbuduj prostą historię: telefon na raty, mała karta
                kredytowa spłacana w całości co miesiąc. Dwa-trzy terminowo
                spłacane zobowiązania to sygnał dla banku: ten człowiek płaci.
              </p>

              <WarnBox title="Uwaga — częsta pułapka">
                Chwilówki i szybkie pożyczki online działają odwrotnie: dla
                banku to czerwona lampka, że brakuje Ci płynności. Jedna
                chwilówka w historii potrafi zablokować kredyt hipoteczny na
                długo. Buduj historię kartą i ratami 0%, nigdy chwilówkami.
              </WarnBox>

              <h3 className="text-base md:text-lg font-extrabold tracking-tight mt-6 mb-2">
                Problem 4: zdolność ucieka przez drobiazgi
              </h3>
              <p className="text-sm md:text-base text-foreground-700 mb-4 leading-relaxed">
                Limit 5 000 zł na koncie, karta kredytowa ze studiów, telefon na
                raty, subskrypcje BNPL (kup teraz, zapłać później) — każda z
                tych rzeczy obniża zdolność, nawet jeśli nic z nich nie
                wykorzystujesz. U młodych, gdzie każda złotówka zdolności się
                liczy, to potrafi przesądzić o odmowie.
              </p>
              <p className="text-sm md:text-base text-foreground-700 mb-4 leading-relaxed">
                <strong>Co zrobić:</strong> na 3 miesiące przed wnioskiem
                zamknij wszystkie nieużywane limity i karty, spłać drobne raty.
                To najprostszy darmowy sposób na podniesienie zdolności o
                kilkadziesiąt tysięcy złotych.
              </p>

              <h3 className="text-base md:text-lg font-extrabold tracking-tight mt-6 mb-2">
                Problem 5: samotny start
              </h3>
              <p className="text-sm md:text-base text-foreground-700 mb-4 leading-relaxed">
                Jedna pensja to jedna zdolność — a ceny mieszkań liczone są jakby
                zarabiały dwie osoby. <strong>Co zrobić:</strong> kredyt można
                wziąć z partnerem (ślub nie jest wymagany), a nawet z rodzicem
                czy rodzeństwem. Współkredytobiorca dokłada swoją zdolność; po
                kilku latach, gdy Twoje dochody urosną, można go z kredytu
                wypisać aneksem. Wariant z rodzicem ma niuanse (wiek wpływa na
                maksymalny okres) — ale i na to są sposoby, np. odpowiednie
                ubezpieczenie.
              </p>

              <Callout />
            </ArticleSection>

            {/* Article 3 */}
            <ArticleSection
              id="konsolidacja"
              tag="Konsolidacja"
              title="Konsolidacja kredytów — ratunek czy pułapka?"
              readTime="5 minut"
              date="lipiec 2026"
            >
              <p className="text-sm md:text-base text-foreground-700 mb-4 leading-relaxed">
                Masz trzy kredyty, dwie karty i telefon na raty. Łączna rata
                wysysa połowę pensji, a terminy spłat mieszają się w głowie.
                Konsolidacja — czyli połączenie wszystkiego w jeden kredyt —
                brzmi jak rozwiązanie. I często nim jest. Ale nie zawsze. W tym
                artykule pokażę, <strong>kiedy konsolidacja naprawdę pomaga</strong>, a kiedy
                tylko odsuwa problem i kosztuje więcej.
              </p>

              <h3 className="text-base md:text-lg font-extrabold tracking-tight mt-6 mb-2">
                Jak działa konsolidacja?
              </h3>
              <p className="text-sm md:text-base text-foreground-700 mb-4 leading-relaxed">
                Bank spłaca Twoje dotychczasowe zobowiązania i zamiast kilku
                rat dajesz mu <strong>jedną, niższą ratę</strong>. Okres spłaty
                się wydłuża, więc pojedyncza rata jest lżejsza. To działa
                najlepiej, gdy masz drogie kredyty gotówkowe czy karty
                kredytowe z oprocentowaniem 15–25% — wtedy zamiana na jeden
                kredyt hipoteczny czy konsolidacyjny z oprocentowaniem 6–9%
                daje realną oszczędność.
              </p>

              <ExampleBox title="Na przykładzie">
                Kredyt gotówkowy 30 000 zł (rata 890 zł), karta kredytowa 8 000
                zł (rata 400 zł), telefon 3 000 zł (rata 150 zł) = łącznie 1
                440 zł miesięcznie. Po konsolidacji w jeden kredyt na 7 lat przy
                7,5%: rata ok. 720 zł. Różnica: 720 zł w kieszeni co miesiąc.
                Ale łączne odsetki wzrosną, bo okres jest dłuższy.
              </ExampleBox>

              <h3 className="text-base md:text-lg font-extrabold tracking-tight mt-6 mb-2">
                Kiedy to ratunek?
              </h3>
              <ul className="list-none m-0 p-0 mb-4">
                {[
                  "Masz kilka drogich kredytów gotówkowych czy kart z wysokim oprocentowaniem.",
                  "Miesięczna rata przekracza 50% dochodu — zagrożenie niewypłacalnością.",
                  "Gubisz się w terminach i spóźnienia zaczynają psuć BIK.",
                  "Masz zdolność, ale forma zatrudnienia się zmieniła — konsolidacja ułatwia negocjacje z bankiem.",
                ].map((item, i) => (
                  <li
                    key={i}
                    className="py-1.5 pl-7 relative text-sm md:text-base text-foreground-700"
                  >
                    <span className="absolute left-1 top-[14px] w-[7px] h-[7px] rounded-full bg-primary-500" />
                    {item}
                  </li>
                ))}
              </ul>

              <h3 className="text-base md:text-lg font-extrabold tracking-tight mt-6 mb-2">
                Kiedy to pułapka?
              </h3>
              <ul className="list-none m-0 p-0 mb-4">
                {[
                  "Wydłużasz okres spłaty z 3 lat na 10 — ratę masz niższą, ale oddajesz bankowi znacznie więcej odsetek.",
                  "Konsolidujesz tylko po to, żeby zrobić miejsce na nowy kredyt — to spirala zadłużenia.",
                  "Nie czytasz drobnego druku — prowizja za wcześniejszą spłatę, ubezpieczenie, opłaty za obsługę.",
                  "Nie zamykasz starych kart i limitów po konsolidacji — podwójny dług zamiast jednego.",
                ].map((item, i) => (
                  <li
                    key={i}
                    className="py-1.5 pl-7 relative text-sm md:text-base text-foreground-700"
                  >
                    <span className="absolute left-1 top-[14px] w-[7px] h-[7px] rounded-full bg-primary-500" />
                    {item}
                  </li>
                ))}
              </ul>

              <WarnBox title="Zasada numer jeden">
                Konsolidacja nie rozwiązuje problemu przekraczania budżetu.
                Jeśli bierzesz ją tylko po to, by zrobić miejsce na nowe
                zakupy, problem wróci silniejszy. Używaj konsolidacji jako
                narzędzia do odzyskania kontroli, nie do odroczenia
                odpowiedzialności.
              </WarnBox>

              <h3 className="text-base md:text-lg font-extrabold tracking-tight mt-6 mb-2">
                Jak to zrobić dobrze?
              </h3>
              <p className="text-sm md:text-base text-foreground-700 mb-4 leading-relaxed">
                <strong>Policz całkowity koszt</strong> — nie tylko ratę.
                Porównaj sumę odsetek przed i po. <strong>Zamknij stare
                zobowiązania</strong> — nie chowaj ich w szufladzie.
                <strong>Wybierz krótszy okres</strong>, na jaki Cię stać — nawet
                o 2 lata mniej znaczą dziesiątki tysięcy. I najważniejsze:{" "}
                <strong>skonsultuj z doradcą</strong>, który sprawdzi oferty w
                kilkunastu bankach i wyliczy prawdziwy koszt, nie tylko ratę.
              </p>

              <Callout />
            </ArticleSection>

            {/* Article 4 */}
            <ArticleSection
              id="zdolnosc"
              tag="Zdolność kredytowa"
              title="7 sposobów na wyższą zdolność kredytową"
              readTime="4 minut"
              date="lipiec 2026"
            >
              <p className="text-sm md:text-base text-foreground-700 mb-4 leading-relaxed">
                Zdolność kredytowa to najważniejsza liczba, o której nigdy
                nie dostajesz wyciągu. Banki liczą ją po swojemu, ale logika
                jest prosta: <strong>ile pieniędzy zostaje Ci po odjęciu
                wszystkich rat i kosztów życia</strong>. Im więcej zostaje,
                tym większy kredyt dostaniesz. Oto 7 ruchów, które realnie
                podnoszą tę liczbę — bez magicznych sztuczek.
              </p>

              <h3 className="text-base md:text-lg font-extrabold tracking-tight mt-6 mb-2">
                1. Zamknij wszystkie nieużywane limity i karty
              </h3>
              <p className="text-sm md:text-base text-foreground-700 mb-4 leading-relaxed">
                Bank traktuje limit 5 000 zł jak dług 5 000 zł — nawet gdy
                nigdy go nie wykorzystałeś. Limit na koncie, zapomniana karta
                studencka, overdraft — każdy z nich obniża zdolność. Zamknięcie
                trzech nieużywanych limitów to często +20 000 zł do
                zdolności od ręki. Darmowe i natychmiastowe.
              </p>

              <h3 className="text-base md:text-lg font-extrabold tracking-tight mt-6 mb-2">
                2. Spłać drobne zobowiązania przed wnioskiem
              </h3>
              <p className="text-sm md:text-base text-foreground-700 mb-4 leading-relaxed">
                Telefon na raty, tablet 0%, meble na 10 rat — każda z tych
                drobnych rzeczy pochłania kawałek zdolności. Jeśli masz
                możliwość, spłać je na 3–6 miesięcy przed wnioskiem o kredyt
                hipoteczny. Efekt kumulatywny kilku małych spłat potrafi dać
                +30 000 zł.
              </p>

              <h3 className="text-base md:text-lg font-extrabold tracking-tight mt-6 mb-2">
                3. Skonsoliduj drogie kredyty
              </h3>
              <p className="text-sm md:text-base text-foreground-700 mb-4 leading-relaxed">
                Kredyt gotówkowy z ratą 900 zł i oprocentowaniem 12% po
                skonsolidowaniu w hipotekę na 7% spada do rata ok. 600 zł.
                Różnica 300 zł miesięcznie = wyższa zdolność na nowy kredyt
                i lżejszy budżet. Pamiętaj tylko, by zamknąć stary kredyt
                po konsolidacji — inaczej oba wiszą w BIK.
              </p>

              <h3 className="text-base md:text-lg font-extrabold tracking-tight mt-6 mb-2">
                4. Dodaj współkredytobiorcę
              </h3>
              <p className="text-sm md:text-base text-foreground-700 mb-4 leading-relaxed">
                Partner, rodzic czy rodzeństwo z dochodami dokłada swoją
                zdolność do Twojej. Przy pensjach 4 000 + 3 500 zł zdolność
                nie jest sumą 7 500 — jest wyższa, bo koszty utrzymania liczą
                się raz, a dochody podwójnie. To najszybszy sposób na
                podwojenie możliwości. Później można współkredytobiorcę
                wypisać aneksem.
              </p>

              <ExampleBox title="W praktyce">
                Samemu przy 5 000 zł netto zdolność to ok. 280 000 zł.
                Z partnerem na 4 500 zł — ok. 520 000 zł. Różnica 240 000 zł
                za darmo, bez podwyżki.
              </ExampleBox>

              <h3 className="text-base md:text-lg font-extrabold tracking-tight mt-6 mb-2">
                5. Wyczyść BIK przed wnioskiem
              </h3>
              <p className="text-sm md:text-base text-foreground-700 mb-4 leading-relaxed">
                Pobierz raport BIK, sprawdź czy nie ma błędów. Stare spóźnienie
                z 3 lat temu, zapomniana rata telefonu, zamknięty kredyt
                wciąż widoczny jako aktywny — to błędy, które da się
                skorygować. Dobry wynik w BIK (powyżej 700) pozwala negocjować
                lepszą marżę i otwiera drzwi w bankach, które dla słabszych
                wyników mają wyższe progi.
              </p>

              <h3 className="text-base md:text-lg font-extrabold tracking-tight mt-6 mb-2">
                6. Wydłuż okres kredytu (z głową)
              </h3>
              <p className="text-sm md:text-base text-foreground-700 mb-4 leading-relaxed">
                Kredyt na 25 lat zamiast 20 to niższa rata i wyższa zdolność.
                Oczywiście więcej odsetek w całym okresie, ale możesz to
                skrócić później nadpłatami. Ważne: wybierz bank bez opłat za
                wcześniejszą spłatę, żeby elastyczność była realna.
              </p>

              <h3 className="text-base md:text-lg font-extrabold tracking-tight mt-6 mb-2">
                7. Pokaż wszystkie dochody — nie tylko pensję
              </h3>
              <p className="text-sm md:text-base text-foreground-700 mb-4 leading-relaxed">
                Umowa zlecenie, najem, dywidendy, świadczenia alimentacyjne —
                część banków liczy je wszystkie, inne tylko część. Ekspert kredytowy
                wie, który bank jak liczy i dobiera bank do Twojego profilu
                dochodowego. Samemu w banku nikt Ci tego nie powie —
                pracownik ma jeden bank i jeden schemat.
              </p>

              <WarnBox title="Co NIE działa">
                Zmyślanie dochodów, fałszywe zaświadczenia, pomoc pośrednika
                za prowizję od dogadania — to droga do odmowy, wpisu w
                rejestrze i utraty wiarygodności na lata. Banki weryfikują
                wszystko. Zdolność buduje się uczciwie, krok po kroku.
              </WarnBox>

              <Callout />
            </ArticleSection>

            <ArticleSection
              id="start-2026"
              tag="Praktyczny start"
              title="Kredyt w sierpniu 2026: od czego zacząć, zanim pójdziesz do banku"
              readTime="6 minut"
              date="sierpień 2026"
            >
              <p className="text-sm md:text-base text-foreground-700 mb-4 leading-relaxed">
                Najgorszy moment na pierwszy kontakt z bankiem to ten, w którym
                rezerwacja mieszkania już wygasa, a Ty dopiero próbujesz
                sprawdzić, czy rata jest w ogóle realna. Dużo spokojniej jest
                zacząć wcześniej: najpierw poznaj swój budżet, potem możliwości,
                a dopiero na końcu wybieraj konkretną ofertę.
              </p>

              <h3 className="text-base md:text-lg font-extrabold tracking-tight mt-6 mb-2">
                Zacznij od kwoty, przy której nadal będziesz spać spokojnie
              </h3>
              <p className="text-sm md:text-base text-foreground-700 mb-4 leading-relaxed">
                Bank policzy maksymalną zdolność. To nie znaczy, że tyle warto
                pożyczyć. Do raty dodaj czynsz, media, dojazdy, ubezpieczenie,
                dzieci, wakacje i zwykłe nieprzewidziane wydatki. Dobra rata to
                taka, która zostawia Ci przestrzeń na życie — również wtedy,
                gdy jeden miesiąc będzie słabszy.
              </p>

              <h3 className="text-base md:text-lg font-extrabold tracking-tight mt-6 mb-2">
                Trzy rzeczy do sprawdzenia przed wnioskiem
              </h3>
              <ul className="list-none m-0 p-0 mb-4">
                {[
                  "Historia spłat — pobierz raport i upewnij się, że zamknięte zobowiązania są rzeczywiście zamknięte.",
                  "Limity i karty — nieużywany limit nadal może obciążać ocenę banku.",
                  "Dokumenty dochodowe — przygotuj je wcześniej, zamiast szukać wszystkiego w dniu składania wniosku.",
                ].map((item, i) => (
                  <li key={i} className="py-1.5 pl-7 relative text-sm md:text-base text-foreground-700">
                    <span className="absolute left-1 top-[14px] w-[7px] h-[7px] rounded-full bg-primary-500" />
                    {item}
                  </li>
                ))}
              </ul>

              <ExampleBox title="Dobry plan zamiast pośpiechu">
                Najpierw sprawdź swoją sytuację, potem porównaj sposób liczenia
                dochodu i kosztów przez kilka banków. Dopiero po tej analizie
                oglądaj mieszkanie z konkretnym budżetem. To daje więcej spokoju
                w negocjacjach i mniej niespodzianek przy umowie.
              </ExampleBox>

              <WarnBox title="Warto pamiętać">
                Sama rozmowa informacyjna nie zobowiązuje do zaciągnięcia
                kredytu. Nie podejmuj decyzji pod presją sprzedawcy, terminu
                promocji czy jednej przedstawionej oferty.
              </WarnBox>
              <Callout />
            </ArticleSection>

            <ArticleSection
              id="stala-czy-zmienna"
              tag="Rata kredytu"
              title="Stała czy zmienna rata? Jak podjąć decyzję spokojnie"
              readTime="5 minut"
              date="sierpień 2026"
            >
              <p className="text-sm md:text-base text-foreground-700 mb-4 leading-relaxed">
                To jedno z najczęstszych pytań przy kredycie hipotecznym. Nie
                ma jednej odpowiedzi dobrej dla wszystkich, bo wybór nie dotyczy
                tylko wysokości raty dziś. Dotyczy też tego, jak reagujesz na
                zmianę kosztów w przyszłości i ile pewności potrzebuje Twój
                domowy budżet.
              </p>

              <ProsCons
                pros={[
                  "Stała rata ułatwia zaplanowanie wydatków na czas obowiązywania stałego oprocentowania.",
                  "Zmienna rata może reagować na zmianę warunków rynkowych, zarówno w górę, jak i w dół.",
                ]}
                cons={[
                  "Przy stałej racie trzeba sprawdzić, co dzieje się po zakończeniu okresu stałego oprocentowania.",
                  "Przy zmiennej racie trzeba zostawić w budżecie zapas na jej możliwy wzrost.",
                ]}
              />

              <h3 className="text-base md:text-lg font-extrabold tracking-tight mt-6 mb-2">
                Zadaj sobie trzy proste pytania
              </h3>
              <p className="text-sm md:text-base text-foreground-700 mb-4 leading-relaxed">
                Czy mój budżet udźwignąłby wyższą ratę? Czy wolę wiedzieć z góry,
                ile płacę przez najbliższe lata? Czy planuję nadpłacać albo
                sprzedać nieruchomość wcześniej? Odpowiedzi są ważniejsze niż
                reklama „najniższej raty”, bo pokazują, jakiej elastyczności
                naprawdę potrzebujesz.
              </p>

              <WarnBox title="Nie porównuj tylko pierwszej raty">
                Sprawdź całkowity koszt, zasady nadpłaty, ubezpieczenia i to,
                jak bank opisuje dalszy okres umowy. Dopiero wtedy porównanie
                ofert jest uczciwe.
              </WarnBox>
              <Callout />
            </ArticleSection>

            {/* Final CTA */}
            <div className="max-w-3xl mx-auto bg-foreground-900 rounded-2xl text-white p-8 md:p-12 text-center">
              <h2 className="text-lg md:text-xl font-extrabold tracking-tight mb-3">
                Masz pytanie po przeczytaniu?
              </h2>
              <p className="text-sm text-foreground-300 max-w-lg mx-auto mb-6">
                Poradniki to dobry start, ale Twoja sytuacja jest unikalna.
                Zadzwoń — przedstawię Ci realne oferty w kilkunastu bankach,
                bez żadnych opłat z Twojej strony.
              </p>
              <a
                href="tel:698084044"
                className="inline-flex items-center gap-3 bg-primary-500 text-white font-extrabold px-8 py-4 rounded-full text-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line" />
                698 084 044
              </a>
              <div className="flex flex-wrap gap-5 justify-center mt-6">
                {["Bezpłatna analiza", "Oferty z 20+ banków", "Bez zobowiązań"].map(
                  (perk) => (
                    <span
                      key={perk}
                      className="text-xs text-foreground-300 flex items-center gap-2"
                    >
                      <i className="ri-check-line text-green-400" />
                      {perk}
                    </span>
                  )
                )}
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
